export const isFlagSetInLocalStorage = (key: string): boolean => {
  try {
    return localStorage.getItem(key)?.toLowerCase() === 'true';
  } catch (_e) {
    return false;
  }
};
